import { useCallback, useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Testimonials } from "@/components/Testimonials";
import { Services } from "@/components/Services";
import { ServiceArea } from "@/components/ServiceArea";
import { WhyUs } from "@/components/WhyUs";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { QuoteModal } from "@/components/QuoteModal";

function App() {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const lenisRef = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  const scrollTo = useCallback((selector) => {
    const el = document.querySelector(selector);
    if (!el) return;
    if (lenisRef.current) {
      lenisRef.current.scrollTo(el, { offset: -76 });
    } else {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  const openQuote = useCallback(() => setQuoteOpen(true), []);
  const closeQuote = useCallback(() => setQuoteOpen(false), []);

  return (
    <div className="min-h-screen bg-sand font-body text-navy">
      <a
        href="#main"
        data-testid="skip-link"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:bg-orange focus:px-4 focus:py-2 focus:font-display focus:uppercase focus:tracking-widest focus:text-navy"
      >
        Skip to content
      </a>
      <Header onNav={scrollTo} />
      <main id="main">
        <Hero onQuote={openQuote} />
        <Marquee />
        <Testimonials />
        <Services />
        <ServiceArea />
        <WhyUs />
        <Contact onQuote={openQuote} />
      </main>
      <Footer onNav={scrollTo} />
      <QuoteModal open={quoteOpen} onClose={closeQuote} />
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#111A26",
            color: "#ffffff",
            border: "2px solid #F5820A",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
